/**
 *
 *  ContentScrollerControls
 *  Component
 *
 *
 *  Created by Vladimir Shishlyannikov on 25/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { memo } from "react";
import useContentScrollerControls from "../../hooks/useContentScrollerControls/useContentScrollerControls";

const [previousButton, nextButton] = ["previous-button", "next-button"];

export const NEXT_BUTTON_NAME = nextButton;
export const PREVIOUS_BUTTON_NAME = previousButton;

const ContentScrollerControls = memo(function ({ contentScrollerApi }) {
  const { onPressForward, onPressReverse } = useContentScrollerControls({
    contentScrollerApi,
  });

  return (
    <div className="content-scroller-controls">
      <button
        type="button"
        data-shared-element-id={nextButton}
        onClick={onPressReverse}
      >
        Show previous
      </button>

      <button
        type="button"
        data-shared-element-id={nextButton}
        onClick={onPressForward}
      >
        Show next
      </button>
    </div>
  );
});

export default ContentScrollerControls;
